import { Navigate } from 'react-router-dom';
import Links from '@/shared/constants/navegacao';

export default function MinhasSessoesPage() {
  return <Navigate to={Links.Usuario_Profile} replace />;
}
